"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCATION_ID = exports.AVAIL_PURPOSE_VISIBILITY = exports.AVAIL_PURPOSE = exports.AVAIL_PATIENT_RELATIONSHIP = exports.PURPOSE = exports.PATIENT_RELATIONSHIP = void 0;
const EHR = 'appointment_ehr_purposes';
exports.PATIENT_RELATIONSHIP = 'patient_relationship';
exports.PURPOSE = 'purpose';
exports.AVAIL_PATIENT_RELATIONSHIP = `${EHR}.${exports.PATIENT_RELATIONSHIP}`;
exports.AVAIL_PURPOSE = `${EHR}.name`;
exports.AVAIL_PURPOSE_VISIBILITY = `${EHR}.ehr_data.visibilities`;
exports.LOCATION_ID = 'location_id';
//# sourceMappingURL=Facets.js.map